import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserSettingsService {

  constructor() { }
  
  // checkPopupsAllowed(): boolean {
  //   // Check if pop-ups are allowed in the browser settings
  //   return window.open('', '_blank') !== null;
  // }


  checkPopupsAllowed(): boolean {
    // Try to open a new window/tab
    const popupWindow = window.open('');
    // Close the opened window/tab
    if (popupWindow) {
      popupWindow.close();
    }
    
    // If a new window/tab is opened, pop-ups are allowed
    const popupsAllowed = popupWindow !== null;
    
    return popupsAllowed;
  }




  checkRedirectsAllowed(): boolean {
    // Check if redirects are allowed in the browser settings
    // You might need to implement browser-specific checks
    return true; // Placeholder logic, replace with actual implementation
  }
}
